import { BaseModel, type RelationConfig } from './base';
import type { Images } from '../types/interfaces/images';

export enum PhotoType {
  customer = 0,
}

export const PhotoTypeLabels: Record<PhotoType, string> = {
  [PhotoType.customer]: 'general.customer',
};

export class Photo extends BaseModel {
  idPhoto!: number;
  imageUrls!: Images;
  type!: PhotoType;
  caption!: string;

  override objectID(): string | null {
    return this.idPhoto?.toString() ?? null;
  }
}
